import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";

enum SendAdministratorRequestServiceEnum {
    SendAcquittanceTerm = "/acquittance",
    SendSolicitationCreditTerm = "/credit",
}

export default class SendAdministratorRequestService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/wallet/administrator/request");
    }

    public SendAcquittanceTerm = async (payload: any): Promise<any[]> => await this.POST(SendAdministratorRequestServiceEnum.SendAcquittanceTerm, payload);
    public SendSolicitationCreditTerm = async (payload: any): Promise<any[]> => await this.POST(SendAdministratorRequestServiceEnum.SendSolicitationCreditTerm, payload);
}


// WEBPACK FOOTER //
// ./src/services/api/SendAdministratorRequest.service.ts